import { ArtBoardNS } from "../../../../../../ArtBoard/ArtBoardNS.js";
import { BackgroundNS } from "../../../../../../Background/BackgroundNS.js";
import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../../../ViewPort/ViewPortNS.js";
export const initEditor = (self) => {
  const canvas_el = self._getCanvasElThrowable();
  const layers_el = self._getLayersElThrowable();
  const art_board_rect_el = self._getArtBoardRectElThrowable();
  const art_board_filter_drop_shadow_el =
    self._getArtBoardFilterDropShadowElThrowable();
  const background_base_el = self._getBackgroundBaseElThrowable();
  const background_color_el = self._getBackgroundColorElThrowable();
  const background_image_el = self._getBackgroundImageElThrowable();
  const view_port = new ViewPortNS.ModelNS.ViewPort({
    width: 0,
    height: 0,
  });
  const view_port_controller = new ViewPortNS.ControllerNS.ViewPortController({
    view_port,
  });
  for (const el of [canvas_el, layers_el]) {
    new ViewPortNS.ViewNS.ViewPortElView({
      view_port_el: el,
      view_port_controller,
    });
  }
  const view_box = new ViewBoxNS.ModelNS.ViewBox({
    svg_el: self._svg_el,
    min_s: 0.4,
    max_s: 2,
  });
  const view_box_controller = new ViewBoxNS.ControllerNS.ViewBoxController({
    view_box,
  });
  new ViewBoxNS.ViewNS.ViewBoxElView({
    view_box_el: layers_el,
    view_box_controller,
  });
  const art_board = new ArtBoardNS.ModelNS.ArtBoard({
    svg_el: self._svg_el,
    getCTM: () => {
      const ctm = art_board_rect_el.getCTM();
      if (ctm == null) {
        throw new Error(`아트보드 엘리먼트의 CTM 을 구할 수 없습니다.`);
      }
      return ctm;
    },
    width: 0,
    height: 0,
  });
  const art_board_controller = new ArtBoardNS.ControllerNS.ArtBoardController({
    art_board,
  });
  new ArtBoardNS.ViewNS.ArtBoardView({
    art_board_controller,
    art_board_rect_el,
    art_board_filter_drop_shadow_el,
  });
  const background = new BackgroundNS.ModelNS.Background({
    value: new BackgroundNS.ModelNS.BackgroundColorValue({
      fill: "none",
      opacity: 1,
    }),
    art_board,
  });
  const background_controller =
    new BackgroundNS.ControllerNS.BackgroundController({
      background,
    });
  new BackgroundNS.ViewNS.BackgroundView({
    background_base_el,
    background_color_el,
    background_image_el,
    background_controller,
  });
  self._view_port = view_port;
  self._view_box = view_box;
  self._art_board = art_board;
  self._background = background;
};
